export default {"src":"/_next/static/media/leaf-icon.311d5469.svg","height":24,"width":24};